const {
	primary, accent, danger, config,
	inquirer, npmPkg, newline
} = require('common')

const getJsx = require('templates/component_jsx')
const getScss = require('templates/component_scss')
const getTest = require('templates/component_test')
const getAngularImport = require('templates/react_2_angular')

const randomColor = require('libraries/random_css_color.js')

const _ 		= require('lodash')
const chalk 	= require('chalk')
const fs 		= require('fs')
const path 	= require('path')
const shell = require('shelljs')

let params = {
	name: undefined,
	app: undefined,
	writeAngularImport: false,
	stateless: true,
	connected: false
}

const APP_ROOT = config.get("ops_client_path")

// TO DO - differentiate between functional and class components

module.exports = args => {

	params.name = args[0]
	params.app = args[1] || "common"


	if (args.length) {
		_generateComponent(params)
	} else {
		_getName()
	}

}

function _getName() {

	newline()

	inquirer
		.prompt([{
			type: 'input',
			name: 'name',
			message: 'name:'
		}])
		.then(({ name }) => {
			params.name = name
			_getApp()
		})
}

function _getApp() {

	inquirer
		.prompt([{
			type: 'list',
			name: 'app',
			choices: npmPkg.apps.map(app => app.name),
			message: 'app:'
		}])
		.then(({ app }) => {
			params.app = app
			_getOptions()
		})

}

function _getOptions() {

	newline()

	inquirer
		.prompt([{
			type: 'confirm',
			name: 'connected',
			message: 'connect to redux?'
		}, {
			type: 'confirm',
			name: 'stateless',
			message: 'make stateless?'
		}, {
			type: 'confirm',
			name: 'writeAngularImport',
			message: 'write react2angular import?'
		}])
		.then(({ stateless, connected, writeAngularImport }) => {

			params = {
				...params,
				stateless,
				connected,
				writeAngularImport
			}

			_generateComponent(params)
		})

}

function _generateComponent({ name, app }) {

	name = name.slice(0, 1).toUpperCase() + _.camelCase(name).slice(1)
	params.name = name

	const color = randomColor()
	params.color = color
	console.log(`\n\tgenerating ${chalk.keyword(color)(name)} in ${app}\n`)

	_writeDirectory(params)

}

function _writeDirectory({ name, app }) {

	params.appDirectory = path.join(APP_ROOT, `/${app}/`)
	const componentDirectory = path.join(
		APP_ROOT, `/${app}/components/${name}`
	)
	params.componentDirectory = componentDirectory

	if (!fs.existsSync(componentDirectory)) {
		fs.mkdirSync(componentDirectory)
		_writeFiles(params)
	} else {
		console.log(danger('ops generate error --'))
		newline()
		console.log(`\tdirectory ${
			danger(name)
		} already exists in ${
			danger(app + '/components/')
		}.`)
		newline()
		return
	}
}

function _writeFiles({
	name, color, connected, stateless,
	componentDirectory
}) {

	const jsx = getJsx(name, { connected, stateless })
	const scss = getScss(name, color)
	const test = getTest(name)

	try {
		fs.writeFileSync(path.join(componentDirectory, `${name}.jsx`), jsx)
		fs.writeFileSync(path.join(componentDirectory, `${name}.scss`), scss)
		fs.writeFileSync(path.join(componentDirectory, `${name}.test.js`), test)
	} catch (err) {
		console.log(danger('ops generate error --'))
		newline()
		console.log(`\tunable to write component files.`)
		newline()
		return
	}

	_writeImports(params)
}

function _writeImports({ name, app, writeAngularImport }) {

	const scssImport = `@import "./components/${name}/${name}";`
	const scssPath = path.join(APP_ROOT, app, `${app}${
		app === 'root' ? ".style" : ""
	}.scss`)
	const scssResult = fs.readFileSync(scssPath, 'utf8')
		.replace(/\/\/ IMPORTS\n/, "\/\/ IMPORTS\n" + scssImport + '\n')

	if (!/\/\/ IMPORTS/.test(scssResult))
		console.log(
			`\t${accent("// IMPORTS")} anchor not found in ${app}.scss`,
			`\n\tplease add import manually:`,
			`\n\t${scssImport}`,
		)

	try {
		fs.writeFileSync(scssPath, scssResult)
	} catch (err) {
		console.log(danger('ops generate error --'))
		newline()
		console.log(`\tunable to write style import.`)
		newline()
		return
	}

	if (writeAngularImport) {
		const jsPath = path.join(APP_ROOT, app, `${app}.js`)
		const jsDest = fs.readFileSync(jsPath, 'utf8')

		const fromScratch = !/react2angular/.test(jsDest)
		const [
			moduleImport, angularRegistry
		] = getAngularImport(name, fromScratch)

		let jsResult

		if (fromScratch) {
			jsResult = jsDest + moduleImport + '\n\n' + angularRegistry
		} else {
			jsResult = jsDest
				.replace(/["']libraries\/react2angular["']/,
					"'libraries\/react2angular'\n" + moduleImport)
				.replace(/\.module\(["']root["']\)/,
					".module('root')" + angularRegistry)
		}

		try {
			fs.writeFileSync(jsPath, jsResult)
		} catch (err) {
			console.log(danger('ops generate error --'))
			newline()
			console.log(`\tunable to write react2angular import.`)
			newline()
			return
		}
	}

	_end(params)

}

function _end({ componentDirectory }) {

	console.log(`\tfinished\n`)

	const editor = config.get("preferred_editor")
	inquirer
		.prompt([{
			type: 'confirm',
			name: 'open',
			message: `open in ${_.lowerCase(editor)}?`
		}])
		.then(({ open }) => {
			if (open)
			shell.exec(`open -a "${editor}" ${componentDirectory}`)
			newline()
		})
}



// WEBPACK FOOTER //
// ./src/commands/generate/component.js